import { Contact } from 'lib/types/models';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const fetchInvoicingContacts = async (
  dispatch: Dispatch,
  businessId: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${businessId}/open/invoicingContacts`,
    dispatch,
  });
  if (response) return response.data;
};

export const fetchContacts = async (dispatch: Dispatch, businessId: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${businessId}/open/contacts`,
    dispatch,
  });
  if (response) return response.data;
};

export const getContacts = async (dispatch: Dispatch, query: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/company/businessesWithContacts?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessGlobalContacts = async (
  dispatch: Dispatch,
  identifier: string,
): Promise<Contact[] | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/business/${identifier}/open/contacts/global`,
    dispatch,
  });
  if (response) return response.data;
};
